import ApplicationAdapter from '../application';

export default class Base extends ApplicationAdapter {
  namespace = 'posts/v4';

  pathForType() {
    return super
      .pathForType(...arguments)
      .replace('posts/', '')
      .toLowerCase();
  }
}
